(function(){
  'use strict';
  try{
    var key='__bigsmall_storage_test__';
    localStorage.setItem(key,'1');
    localStorage.removeItem(key);
    return;
  }catch(error){}

  var memory={};
  try{
    if(!window.Storage)return;
    var get=Storage.prototype.getItem,set=Storage.prototype.setItem,remove=Storage.prototype.removeItem;
    Storage.prototype.getItem=function(key){try{return get.call(this,key)}catch(error){return Object.prototype.hasOwnProperty.call(memory,key)?memory[key]:null}};
    Storage.prototype.setItem=function(key,value){try{return set.call(this,key,value)}catch(error){memory[key]=String(value)}};
    Storage.prototype.removeItem=function(key){try{return remove.call(this,key)}catch(error){delete memory[key]}};
  }catch(error){}
})();
